var echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/radar');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
export default {
    data() {
        return {
            alert: {
                isshow: false,
            },
            servantId: this.$route.params.servantId,
            jobId: this.$route.params.jobId ? parseInt(this.$route.params.jobId) : 0,
            // curTabId: parseInt(this.$route.params.tabid),
            jobType: parseInt(this.$route.query.jobType),
            //平台: 0:用户端(默认),2:客户经理端,3:服务师端
            platform: this.$route.query.platform ? parseInt(this.$route.query.platform) : 0,
            //上一页面: 0:不确认(默认),1:用户端服务师列表,2:客户经理端服务师列表,3:服务师端邀请评价,4:客户经理端代下单发单列表
            fromPage: this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 0,
            userType: this.$route.query.ut ? parseInt(this.$route.query.ut) : 0, //用户类型: 0|空:客户, 2:管家
            //操作类型: 0:不确认(默认),2:发送邀请
            handleType: this.$route.query.handleType ? parseInt(this.$route.query.handleType) : 0,
            jobApplicationId: this.$route.query.jobApplicationId ? parseInt(this.$route.query.jobApplicationId) : 0, //客户经理端代下单发送邀请Id
            //来源: 0:不确认(默认),1:微信分享着陆页
            sourceType: this.$route.query.sourceType ? parseInt(this.$route.query.sourceType) : 0,
            catId: parseInt(this.$route.query.catId), //服务师列表页带的参数
            schKey: this.$route.query.schKey ? this.$route.query.schKey : "", //服务师列表页带的参数
            detailData: {
                resumeData: {},
                commentList: {},
                orderList: [],
            },
            swiperPhotoOption: { //照片滑块参数
                notNextTick: true,
                roundLengths : true,
                direction : 'horizontal',
                speed: 300,
                autoplayDisableOnInteraction: false,
                grabCursor: true,
                autoHeight: false,
                effect: "slide",
                setWrapperSize :true,
                pagination : '.swiper-pagination',
                paginationType: "fraction",
                paginationClickable: true,
                paginationHide: false,
                prevButton:'null',
                nextButton:'null',
                mousewheelControl : true,
                observeParents:false,
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                initialSlide: 0,
                loop: false,
            },
            swiperPhotoList: [ //滑块照片|证书列表
                {
                    ImageUrl: require("../../assets/images/picture_default_hollow_white.png"),
                },
                // {
                //     ImageUrl: "http://d.hiphotos.baidu.com/image/pic/item/faf2b2119313b07e5119db2301d7912397dd8c71.jpg"
                // },
                // {
                //     ImageUrl: "http://c.hiphotos.baidu.com/image/pic/item/9d82d158ccbf6c81924a92c5b13eb13533fa4099.jpg"
                // },
                // {
                //     ImageUrl: "http://a.hiphotos.baidu.com/image/pic/item/0dd7912397dda1449dd17697bfb7d0a20cf4863e.jpg"
                // },
                // {
                //     ImageUrl: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1536600454348&di=82fba7709c377c1a57c9eed43c19a805&imgtype=0&src=http%3A%2F%2Fpic8.nipic.com%2F20100723%2F5144728_201710004015_2.jpg"
                // }
            ],
            expectedSalary: "面议", //期望工资
            expectedSalaryUnit: "", //期望工资单位
            telephoneNum: null, //电话号码
            seniority: 0, //工龄
            jobTypeStr: "", //工作类型
            isLoaded: false, //是否完成加载
            avatarReplace: require("../../assets/images/i_logo.png"), //替代头像
            advantage: [ //优势
                {
                    id: 1,
                    name: "质量保证",
                    image: require("../../assets/images/i_heart.png")
                },
                {
                    id: 2,
                    name: "精准匹配",
                    image: require("../../assets/images/i_eye.png")
                },
                {
                    id: 3,
                    name: "身份证验视",
                    image: require("../../assets/images/i_magnifier.png")
                },
                {
                    id: 4,
                    name: "售后无忧",
                    image: require("../../assets/images/i_basket.png")
                },
            ],
            skillList: [ //个人技能
                {
                    SkillType: 1,
                    Score: 0,
                    SkillTypeStr: "保洁",
                },
                {
                    SkillType: 2,
                    Score: 0,
                    SkillTypeStr: "母婴",
                },
                {
                    SkillType: 3,
                    Score: 0,
                    SkillTypeStr: "烹饪",
                },
                {
                    SkillType: 4,
                    Score: 0,
                    SkillTypeStr: "育儿",
                },
                {
                    SkillType: 5,
                    Score: 0,
                    SkillTypeStr: "护理",
                },
            ],
            isShowHistoryOrder: false, //是否打开历史订单

            isMiniProgram: this.$isMiniProgram(), //是否小程序环境
            isAPP: false, //是否APP环境
            isShowDownloadGuideBar: false, //是否显示下载引导条
            isShowMenuPopupRightTop: false, //是否显示右上角弹出菜单
            isShowSharePanel: false, //是否显示分享面板
            shareQRCode: "", //分享二维码
        }
    },
    // beforeCreate(){
    //     document.title = '服务';
    // },
    // created(){
    //     document.title = '服务';
    // },
    // beforeMount(){
    //     document.title = '服务';
    // },
    mounted() {
        this.init();
        // this.updatePageTitle();
    },
    // beforeUpdate(){
    //     this.updatePageTitle();
    // },
    // updated(){
    //     this.updatePageTitle();
    // },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'serverDetail') {
                this.init();
            }
        }
    },
    methods: {
        //修改当前页面title
        // updatePageTitle(){
        //     document.title = '服务';
        // },
        //数据初始化
        init() {
            this.servantId = this.$route.params.servantId;
            this.jobId = this.$route.params.jobId ? parseInt(this.$route.params.jobId) : 0;
            // this.curTabId = parseInt(this.$route.params.tabid);
            this.jobType = parseInt(this.$route.query.jobType);
            this.platform = this.$route.query.platform ? parseInt(this.$route.query.platform) : 0;
            this.fromPage = this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 0;
            this.userType = this.$route.query.ut ? parseInt(this.$route.query.ut) : 0;
            this.handleType = this.$route.query.handleType ? parseInt(this.$route.query.handleType) : 0;
            this.jobApplicationId = this.$route.query.jobApplicationId ? parseInt(this.$route.query.jobApplicationId) : 0;
            this.sourceType = this.$route.query.sourceType ? parseInt(this.$route.query.sourceType) : 0;
            this.swiperPhotoList = [ //滑块照片|证书列表
                {
                    ImageUrl: require("../../assets/images/picture_default_hollow_white.png"),
                },
            ];
            this.expectedSalary = "面议";
            this.expectedSalaryUnit = "";
            this.telephoneNum = null;
            this.seniority = 0;
            this.jobTypeStr = "";
            this.isLoaded = false;
            this.isShowHistoryOrder = false;
            this.isShowDownloadGuideBar = false;
            this.isShowMenuPopupRightTop = false;
            this.isShowSharePanel = false;
            this.shareQRCode = "";
            this.checkCurPlatform();
            this.initSkillList();
            this.getDetail();
        },
        //检测当前环境
        checkCurPlatform() {
            this.isMiniProgram = this.$isMiniProgram();
            this.isAPP = dsBridge.hasNativeMethod('getSession');
            if (!this.isMiniProgram && !this.isAPP) {
                this.isShowDownloadGuideBar = true;
            }
        },
        //获取详情信息
        getDetail() {
            //拉取数据后，分别传递相应数据给server-resume、server-comment-list、server-order-list
            var self = this;
            let _param = {
                servantId: this.servantId,
            };
            if (this.platform == 2 && this.jobId && this.fromPage == 4) {
                _param.jobid = this.jobId;
            }
            if (this.platform == 2 && this.fromPage == 4) {
                _param.interfaceType = 1;
            }
            this.$get("/servant/getservant", _param, function(result) {
                if (result && result.AccountCode) {
                    let resume = JSON.parse(JSON.stringify(result));
                    resume.ListOrder = [];
                    resume.HistoryEvaluate = {};
                    resume.ListServantPhones = [];
                    self.detailData.resumeData = resume;
                    if(self.detailData.resumeData.ServantPhoto){
                        self.swiperPhotoList[0].ImageUrl = self.detailData.resumeData.ServantPhoto;
                    }
                    if(self.detailData.resumeData.ListServantPicture && self.detailData.resumeData.ListServantPicture.length>0){
                        self.detailData.resumeData.ListServantPicture.map(item => {
                            if(item.PositivePhoto){
                                let newItem = {
                                    ImageUrl: item.PositivePhoto
                                }
                                self.swiperPhotoList.push(newItem);
                            }
                            if(item.ReversePhoto){
                                let newItem = {
                                    ImageUrl: item.ReversePhoto
                                }
                                self.swiperPhotoList.push(newItem);
                            }
                        });
                    }
                    //用户评价
                    if (result.HistoryEvaluate && result.HistoryEvaluate.ListServantEvaluate && result.HistoryEvaluate.ListServantEvaluate.length > 0) {
                        self.detailData.commentList = result.HistoryEvaluate.ListServantEvaluate;
                    } else {
                        self.detailData.commentList = [];
                    }
                    self.detailData.orderList = result.ListOrder;
                    //期望工资、工作年限、工作类型
                    if (self.detailData.resumeData.ServantSkill && self.detailData.resumeData.ServantSkill.length > 0) {
                        self.detailData.resumeData.ServantSkill.map(item => {
                            if (item.JobType == self.jobType) {
                                self.expectedSalary = item.ExpectedSalary;
                                self.expectedSalaryUnit = item.SalaryUnitStr;
                                if (self.detailData.resumeData.CsCellphone) {
                                    self.telephoneNum = self.detailData.resumeData.CsCellphone;
                                } else {
                                    self.telephoneNum = self.detailData.resumeData.Cellphone;
                                }
                                self.seniority = item.WorkingYears;
                                self.jobTypeStr = item.JobTypeStr;
                            }
                        });
                    }
                    //个人技能
                    let myChart = echarts.init(self.$el.querySelector("#myChart"));
                    if (self.detailData.resumeData.ListWorkingSkills && self.detailData.resumeData.ListWorkingSkills.length > 0) {
                        self.detailData.resumeData.ListWorkingSkills.map(item => {
                            self.setSkillList(item);
                        });
                    }
                    let indicator = [];
                    let seriesValue = [];
                    self.skillList.map(item => {
                        let newItem = {
                            text: item.SkillTypeStr,
                            max: 5
                        };
                        indicator.push(newItem);
                        seriesValue.push(item.Score);
                    });
                    myChart.setOption({
                        // title : {
                        //     text: '个人技能',
                        //     subtext: '个人技能数据'
                        // },
                        tooltip: {
                            trigger: 'axis'
                        },
                        // legend: {
                        //     x : 'center',
                        //     data:['个人技能']
                        // },
                        // toolbox: {
                        //     show : true,
                        //     feature : {
                        //         mark : {show: true},
                        //         dataView : {show: true, readOnly: false},
                        //         restore : {show: true},
                        //         saveAsImage : {show: true}
                        //     }
                        // },
                        calculable: true,
                        polar: [{
                            indicator: indicator,
                            radius: 108
                        }],
                        series: [{
                            name: '个人技能数据',
                            type: 'radar',
                            itemStyle: {
                                normal: {
                                    areaStyle: {
                                        type: 'default'
                                    }
                                }
                            },
                            data: [{
                                value: seriesValue,
                                // name: '个人技能'
                            }]
                        }]
                    });
                    self.isLoaded = true;
                } else {
                    self.alert = {
                        cont: "出错了"
                    };
                    self.alert = self.$uAlert.show_alert(self.alert);
                }
            });
        },
        //去评价
        toComment() {
            let self = this;
            if (!this.isMiniProgram && !this.isAPP) {
                this.$toast("请先安装U+私人管家，点击底部按钮就可下载哦~");
                this.isShowDownloadGuideBar = true;
            } else {
                this.$router.push({
                    path: "/commentServer/" + this.detailData.resumeData.ServantId + "/" + this.jobId,
                    query: {
                        jobType: this.jobType,
                        ut: self.userType,
                    }
                });
            }
        },
        //历史订单
        switchHistoryOrder() {
            this.isShowHistoryOrder = !this.isShowHistoryOrder;
        },
        //初始化个人技能
        initSkillList() {
            this.skillList.map(item => {
                item.Score = 0;
            });
        },
        //设置个人技能
        setSkillList(parameterItem) {
            this.skillList.map(item => {
                if (item.SkillType == parameterItem.SkillType) {
                    item.Score = parseFloat(parameterItem.AverageScore);
                }
            });
        },
        ////拨打电话
        //telephone() {
        //    // window.location.href = "tel://" + phone;
        //    if (this.detailData.resumeData && this.detailData.resumeData.Cellphone) {
        //        this.$telephone(this.detailData.resumeData.Cellphone);
        //    }
        //},
        //预约下单
        toOrder() {
            let self = this;
            var resumeData = this.detailData.resumeData;
            if (this.platform == 2) { //客户经理端
                if (this.jobId > 0) { //有订单ID
                    if (self.fromPage == 4) { //来自代下单
                        if (self.handleType && self.handleType == 2 && self.jobApplicationId && self.jobApplicationId > 0) {
                            // self.subInvite();
                            self.selfAlert("确定要发送邀请吗？", self.subInvite, 2, false);
                        } else {
                            self.$toast("数据出错");
                        }
                    } else {
                        this.$router.push({
                            name: "salary",
                            query: {
                                JobId: this.jobId,
                                ServantAccountCode: resumeData.AccountCode,
                                ProfileStoreId: resumeData.ProfileStoreId,
                                ServantName: resumeData.ServantName
                            }
                        });
                    }
                } else {
                    var jobType = [];
                    if (resumeData.ServantSkill) {
                        for (var i = 0; i < resumeData.ServantSkill.length; i++) {
                            jobType.push(resumeData.ServantSkill[i].JobType);
                        }
                    }
                    this.$router.push({
                        name: "matchJob",
                        query: {
                            id: this.$route.query.id || this.servantId,
                            AccountCode: resumeData.AccountCode,
                            ProfileStoreId: resumeData.ProfileStoreId,
                            ServantName: resumeData.ServantName,
                            jobType: jobType.join(',')
                        }
                    });
                }
            } else {
                if (this.platform == 3) {
                    this.recommend();
                } else {
                    if (!this.isMiniProgram && !this.isAPP) {
                        this.$toast("请先安装U+私人管家，点击底部按钮就可下载哦~");
                        this.isShowDownloadGuideBar = true;
                    } else {
                        this.$router.push({
                            path: "/category",
                            query: {
                                servantId: resumeData.ServantId
                            }
                        });
                    }
                }
            }
        },
        //推荐分享 - 服务师端
        recommend() {
            var self = this;
            if (this.platform == 3) {
                if (!this.shareQRCode || this.shareQRCode == "") {
                    // this.$get("/servant/qccode", {
                    //     jobtype: self.jobType,
                    // }, function(result) {
                    //     if (result) {
                    //         console.log(result);
                    //         self.shareQRCode = result;
                    //         self.isShowSharePanel = true;
                    //     } else {
                    //         self.$toast("出错了");
                    //     }
                    // });
                    self.shareQRCode = process.env.apiHost + "servant/qccode?s=" + window.sessionStorage.getItem("session") + "&jobtype=" + self.jobType;
                    self.isShowSharePanel = true;
                } else {
                    this.isShowSharePanel = true;
                }
            }
        },
        closeSharePanel() {
            this.isShowSharePanel = false;
        },

        //发送邀请
        subInvite() {
            let self = this;
            let inviteList = [self.jobApplicationId];
            let _param = {
                JobId: this.jobId,
                JobApplicationId: inviteList,
                ServantId: this.servantId,
                InvitationType: 1
            };
            this.$post("/customerservicemanager/sendinvitation", _param, function(ret) {
                if (ret.Success) {
                    self.$toast("发送成功");
                    self.$router.push({
                        path: "/release/clientJobList/1",
                        query: {
                            ut: self.userType,
                        }
                    });
                } else {
                    self.$toast(ret.Message);
                }
            });
        },

        //自定义返回
        customBack() {
            let self = this;
            let _param = {
                ut: self.userType,
            };
            if (this.catId && this.catId > 0) {
                _param.catId = this.catId;
            }
            if (this.schKey && this.schKey != "") {
                _param.schKey = this.schKey;
            }
            if (this.platform == 2) { //客户经理端
                if (self.fromPage == 4) { //来自代下单
                    self.$router.push({
                        path: "/release/clientJobList/1",
                        query: {
                            ut: self.userType,
                        }
                    });
                } else { //服务师列表
                    this.$router.push({
                        path: "/serverList",
                        query: _param
                    });
                }
            } else if (this.platform == 1) { //客户端
                if (!this.jobId) { //有订单号
                    this.$router.push({
                        path: "/serverList",
                        query: _param
                    });
                } else {
                    this.$router.go(-1);
                }
            } else {
                this.$router.go(-1);
            }
        },
        //右上角弹出菜单开关
        switchMenuPopupRightTop(){
            this.isShowMenuPopupRightTop = !this.isShowMenuPopupRightTop;
        },
        //关闭右上角弹出菜单
        closeMenuPopupRightTop(){
            let self = this;
            this.closeMenuPopupRightTopSelf();
            let delayCloseMenuPopup = setTimeout(() => {
                self.isShowMenuPopupRightTop = false;
            },500);
        },
        //关闭右上角弹出菜单 - 调用组件本身关闭
        closeMenuPopupRightTopSelf(){
            this.$refs.menupopup.closePanel();
        },
        //分享
        customShare() {
            let shareData = {
                Title: this.detailData.resumeData.ShareTitle, //分享标题encodeURIComponent()
                Link: process.env.clubHost + "/serverDetail/" + this.servantId + "/" + this.jobId +
                    "?jobType=" + this.jobType + "&platform=0&sourceType=1", //分享链接
                Image: this.detailData.resumeData.ShareImage, //分享预览图
                Desc: this.detailData.resumeData.ShareDesc
            };
            this.$appShare(shareData);
            this.closeMenuPopupRightTop();
        },
        //编辑阿姨个人信息
        toEditProfile(){
            if(this.platform == 2){
                this.$router.push({
                    path: "/serverProfile",
                    query: {
                        servantId: this.detailData.resumeData.ServantId,
                        platform: 2
                    }
                });
            }
            this.closeMenuPopupRightTop();
        },

        //下载引导条开关
        switchDownloadGuideBar() {
            this.isShowDownloadGuideBar = !this.isShowDownloadGuideBar;
        },
        //提示
        selfAlert(cont, callback, dialogType, cancelCallback) {
            let self = this;
            self.alert = {
                cont: cont,
                callback: callback ? callback : false,
                dialogType: dialogType ? dialogType : 1,
                cancelCallback: cancelCallback ? cancelCallback : false,
            };
            self.alert = self.$uAlert.show_alert(self.alert);
        },
    },
}


// WEBPACK FOOTER //
// ./src/shared/components/server/server-detail.js